import React from "react";
//home page can be changed for any page
import CenterPanelAppointmentAdvanced from "./centerPanel";
import ReusableBottomPanelAppointmentAdvanced from "../appointment/components/reusableBottomPanel";

export default function AppointmentAdvancedContent() {
  return (
    <div className="appointment-advanced-step">
      <CenterPanelAppointmentAdvanced />
      <ReusableBottomPanelAppointmentAdvanced validationDataGroup="secondStepAdvancedAppointment" />
    </div>
  );
}
